<template>
  <p :class="['cancel_content', {'is-centered': isCentered}]">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: "CancelContent",
  props: {
    isCentered: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss" scoped>

.cancel_content {
  margin-bottom: 6px;
  line-height: 1.3;

  &.is-centered {
    text-align: center;
  }
}
</style>
